import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link, Typography } from '@mui/material';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { markNotificationAsRead } from '../../core/notifications/action';
import { CustomBox } from './styled';
import './styles.css';

function NotificationRow({ notification, groupedIds }) {
  const dispatch = useDispatch();
  const { message, read, details } = notification;
  const [clicked, setClicked] = React.useState(read);
  const CustomizedSwal = withReactContent(Swal);

  const onClick = () => {
    setClicked(true);

    // Mark all grouped notifications as read
    if (groupedIds && groupedIds.length > 0) {
      groupedIds.forEach((id) => dispatch(markNotificationAsRead(id)));
    } else {
      dispatch(markNotificationAsRead(notification.id));
    }

    if (!details) return;

    CustomizedSwal.fire({
      title: notification.short_title,
      text: details,
      confirmButtonColor: '#0997ba',
      footer: notification.additional_url && (
        <Link href={notification.additional_url}>
          {notification.additional_url_text ?? 'Check'}
        </Link>
      ),
    });
  };

  return (
    <CustomBox read={read || clicked} clickable={!!details} onClick={onClick}>
      <Typography variant="body1">{message}</Typography>
    </CustomBox>
  );
}

NotificationRow.propTypes = {
  notification: PropTypes.instanceOf(Object).isRequired,
  groupedIds: PropTypes.arrayOf(PropTypes.number),
};

NotificationRow.defaultProps = {
  groupedIds: null,
};

export default NotificationRow;
